<template>
    <div class="card">
        <div class="flex justify-content-between align-items-center mb-4">
            <h3>Gestione Tipologie Prodotto</h3>
            <Button label="Nuova Tipologia" icon="pi pi-plus" @click="openDialog()" />
        </div>

        <DataTable :value="types" :reorderableColumns="true" @rowReorder="onRowReorder" responsiveLayout="scroll">
            <Column rowReorder :headerStyle="{width: '3rem'}" :bodyStyle="{textAlign: 'center'}"></Column>
            <Column field="nome" header="Nome"></Column>
            <Column field="count_prodotti" header="Prodotti">
                <template #body="slotProps">
                    <span style="cursor:pointer; color: var(--primary-color); font-weight: bold; text-decoration: underline;" @click="openProductList(slotProps.data)">
                        {{ slotProps.data.count_prodotti || 0 }} Prodotti
                    </span>
                </template>
            </Column>
            <Column header="Azioni" :exportable="false" style="min-width:8rem">
                <template #body="slotProps">
                    <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="openDialog(slotProps.data)" />
                    <Button icon="pi pi-trash" class="p-button-rounded p-button-warning" @click="confirmDelete(slotProps.data)" />
                </template>
            </Column>
        </DataTable>

        <Dialog v-model:visible="productDialog" :style="{width: '450px'}" header="Dettagli Tipologia" :modal="true" class="p-fluid">
            <div class="field">
                <label for="name">Nome</label>
                <InputText id="name" v-model="type.nome" required="true" autofocus :class="{'p-invalid': submitted && !type.nome}" />
                <small class="p-error" v-if="submitted && !type.nome">Nome è obbligatorio.</small>
            </div>
            <template #footer>
                <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="hideDialog" />
                <Button label="Salva" icon="pi pi-check" class="p-button-text" @click="saveType" />
            </template>
        </Dialog>

        <Dialog v-model:visible="deleteProductDialog" :style="{width: '450px'}" header="Conferma" :modal="true">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                <span v-if="type">Sei sicuro di voler eliminare <b>{{type.nome}}</b>?</span>
            </div>
            <template #footer>
                <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteProductDialog = false" />
                <Button label="Sì" icon="pi pi-check" class="p-button-text" @click="deleteType" />
            </template>
        </Dialog>

        <Dialog v-model:visible="productListDialog" :style="{width: '600px'}" :header="'Prodotti - ' + (selectedType?.nome || '')" :modal="true">
            <DataTable :value="products" :reorderableColumns="true" @rowReorder="onProductReorder" responsiveLayout="scroll">
                <Column rowReorder :headerStyle="{width: '3rem'}" :bodyStyle="{textAlign: 'center'}"></Column>
                <Column field="nome" header="Nome Prodotto"></Column>
            </DataTable>
            <template #footer>
                <Button label="Chiudi" icon="pi pi-times" class="p-button-text" @click="productListDialog = false" />
            </template>
        </Dialog>
    </div>
</template>

<script>
import { ref, onMounted, getCurrentInstance } from 'vue';
import Service from '@/services/levante-api/levante-api';
import { useToast } from 'primevue/usetoast';

export default {
    setup() {
        const self = getCurrentInstance();
        self.$eventBus = self.appContext.config.globalProperties.$eventBus;
        const service = new Service(self.$eventBus);
        const toast = useToast();

        const types = ref([]);
        const productDialog = ref(false);
        const deleteProductDialog = ref(false);
        const productListDialog = ref(false);
        const type = ref({});
        const selectedType = ref(null);
        const products = ref([]);
        const submitted = ref(false);

        const loadTypes = async () => {
            const res = await service.getTypeProdottiAll();
            if (res.items.status === 'success') {
                types.value = res.items.data;
            }
        };

        onMounted(() => {
            loadTypes();
        });

        const openDialog = (data) => {
            type.value = data ? { ...data } : {};
            submitted.value = false;
            productDialog.value = true;
        };

        const hideDialog = () => {
            productDialog.value = false;
            submitted.value = false;
        };

        const saveType = async () => {
            submitted.value = true;
            if (type.value.nome && type.value.nome.trim()) {
                const res = await service.saveTypeProdotto(type.value, type.value.id);
                if (res.item.status === 'success') {
                    toast.add({ severity: 'success', summary: 'Successo', detail: 'Tipologia salvata', life: 3000 });
                    productDialog.value = false;
                    type.value = {};
                    loadTypes();
                } else {
                    toast.add({ severity: 'error', summary: 'Errore', detail: res.item.message, life: 3000 });
                }
            }
        };

        const confirmDelete = (data) => {
            type.value = data;
            deleteProductDialog.value = true;
        };

        const deleteType = async () => {
            const res = await service.deleteTypeProdotto(type.value.id);
            if (res.item.status === 'success') {
                toast.add({ severity: 'success', summary: 'Successo', detail: 'Tipologia eliminata', life: 3000 });
                deleteProductDialog.value = false;
                type.value = {};
                loadTypes();
            } else {
                toast.add({ severity: 'error', summary: 'Errore', detail: res.item.message, life: 3000 });
            }
        };

        const onRowReorder = async (event) => {
            types.value = event.value;
            const items = types.value.map((t, index) => ({ id: t.id, order: index }));
            await service.reorderTypeProdotti(items);
            toast.add({ severity: 'success', summary: 'Successo', detail: 'Ordinamento aggiornato', life: 3000 });
        };

        const openProductList = async (data) => {
            selectedType.value = data;
            const res = await service.getTypeProdottoProducts(data.id);
            if (res.items && res.items.status === 'success') {
                products.value = res.items.data;
                productListDialog.value = true;
            } else if (res.item && res.item.status === 'success') {
                // handle different response wrapping depending on getGetByUrl
                products.value = res.item.data;
                productListDialog.value = true;
            }
        };

        const onProductReorder = async (event) => {
            products.value = event.value;
            const items = products.value.map((p, index) => ({ id: p.id, order: index }));
            const res = await service.reorderTypeProdottoProducts(items);
            if (res.item.status === 'success') {
                toast.add({ severity: 'success', summary: 'Successo', detail: 'Ordine prodotti aggiornato per l\'app', life: 3000 });
            } else {
                toast.add({ severity: 'error', summary: 'Errore', detail: 'Impossibile aggiornare ordinamento', life: 3000 });
            }
        };

        return {
            types,
            productDialog,
            deleteProductDialog,
            type,
            submitted,
            openDialog,
            hideDialog,
            saveType,
            confirmDelete,
            deleteType,
            onRowReorder,
            productListDialog,
            selectedType,
            products,
            openProductList,
            onProductReorder
        };
    }
}
</script>
